module.exports = __webpack_public_path__ + "static/media/Sequel100Black-45.f76c4727.ttf";